<template>
  <div>
    <UserManagementLayout>
      <PageHeader slot="page-header" :title="$t('access.user_list.header')" />
      <UserManagementItem slot="user-management-item" />
    </UserManagementLayout>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import './styles/user-management.scss';
import PageHeader from '@/components/common/PageHeader/PageHeader.vue';
import UserManagementLayout from './components/UserManagementLayout/UserManagementLayout.vue';
import UserManagementItem from './components/UserManagementItem/UserManagementItem.vue';

@Component({
  components: {
    PageHeader,
    UserManagementLayout,
    UserManagementItem
  }
})
export default class UserManagement extends Vue {}
</script>
